import { Component, OnInit } from '@angular/core';
import { BoobleModalService } from 'booble-modal';
import { Subject, throwError } from 'rxjs';
import { catchError, debounceTime, switchMap } from 'rxjs/operators';

import { SettlementDocumentsComponent } from '../settlement-documents/settlement-documents.component';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { ActivatedRoute } from '@angular/router';
import { EOrderStatusFlow } from 'src/app/domain/enums/order-status-types.enum';
import { ExchangeDetailsComponent } from '../exchange-details/exchange-details.component';
import { PageEvent } from '@angular/material/paginator';
import { AdminOrderDetailModalComponent } from '../../../home/modals/order-details-modal/admin-order-detail-modal.component';
import { ExchangeOrder } from 'src/app/domain/models/exchange-order.model';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-exchange-orders',
  templateUrl: './exchange-orders.component.html',
  styleUrls: ['./exchange-orders.component.scss'],
})
export class ExchangeOrdersComponent implements OnInit {
  private searchSubject = new Subject<string>();
  boobleModalData: string;

  public ordersExchange: ExchangeOrder[] = [];
  public filteredItems: ExchangeOrder[] = [];
  public totalElements: number = 0;
  haveOrders: boolean;
  statusFlow: string = '';
  searchText: string = '';
  loading: boolean;

  pageSize: number = 10;
  pageNumber: number = 0;

  constructor(
    private modalService: BoobleModalService,
    private readonly route: ActivatedRoute,
    private readonly ordersService: OrdersService,
    private readonly notifierService: NotifierService
  ) { }

  ngOnInit() {
    this.statusFlow = `flow=${EOrderStatusFlow.PAID}`;

    this.ordersService.listenerUpdate.subscribe(() => {
      this.initialize();
    });

    this.searchSubject.pipe(debounceTime(1500)).subscribe((search) => {
      this.pageNumber = 0;
      this.initialize(search);
    });
  }

  onSearchChange(search: string) {
    this.searchSubject.next(search);
  }

  initialize(search?: string) {
    this.loading = true;
    this.ordersExchange = [];

    this.ordersService
      .getExchangeOrders(
        this.pageNumber + 1,
        this.pageSize,
        search
      )
      .subscribe({
        next: (result) => {
          this.loading = false;

          this.totalElements = result.data?.totalElements ?? 0;

          if (result.data?.content?.length > 0) {
            this.ordersExchange = result.data.content;
            this.haveOrders = true;
            this.filteredItems = this.ordersExchange;
          } else {
            this.filteredItems = [];
            this.haveOrders = false;
          }
        },
        error: (err) => {
          this.loading = false;
          this.haveOrders = false;
        },
      });
  }

  reprocess(exchangeOrder: ExchangeOrder) {
    exchangeOrder.reprocessing = true;
    this.ordersService.reprocess(exchangeOrder.externalId)
      .pipe(
        catchError(err => {
          exchangeOrder.reprocessing = false;
          exchangeOrder.errorMessage = err.error;
          this.notifierService.notify('error', err.error);
          return throwError(() => err);
        }),
        switchMap(result => {
          return this.ordersService.getExchangeOrders(this.pageNumber, this.pageSize, exchangeOrder.id.toString())
        })
      )
      .subscribe({
        next: (resultSuccess) => {
          const eo = resultSuccess.data.content[0];
          this.ordersExchange[this.ordersExchange.indexOf(exchangeOrder)] = eo;
          this.notifierService.notify('success', 'Boleto integrado com sucesso.');
        }
      });
  }

  import() {
    this.loading = true;
    this.ordersService.import(this.searchText)
      .subscribe({
        next: (result => {
          this.searchSubject.next(this.searchText);
          this.notifierService.notify('success', 'Boleto importado com sucesso.');
          this.loading = false;
        }),
        error: (err) => {
          this.loading = false;
          this.notifierService.notify('error', err.error);
        }
      });
  }

  filterExchangeOrders() {
    this.pageNumber = 0;
    this.initialize(this.searchText);
  }

  onChangePage(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;

    this.initialize(this.searchText);
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openSettlementDocumentsComponentModal(orderId: number) {
    this.modalService.present(SettlementDocumentsComponent, orderId);
  }

  goOrderDetail(orderId: number) {
    this.modalService.present(AdminOrderDetailModalComponent, orderId);
  }
}
